import {useEffect} from "react";

const GoogleAnalytics = () => {
  const isProduction = process.env.NODE_ENV === "production";
  const gaId = process.env.REACT_APP_GA_MEASUREMENT_ID;

  useEffect(() => {
    if (!isProduction || !gaId) {
      return;
    }

    const script1 = document.createElement("script");
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    script1.async = true;
    document.head.appendChild(script1);

    const script2 = document.createElement("script");
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${gaId}');
    `;
    document.head.appendChild(script2);

    return () => {
      const existingScripts = document.querySelectorAll(
        `script[src*="googletagmanager"]`
      );
      existingScripts.forEach(script => script.remove());
    };
  }, [isProduction, gaId]);

  return null;
};

export default GoogleAnalytics;
